import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, tap, catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UpdatePremiumDto, UserDto } from '../models/api.models';
import { AuthService } from './auth.service';
import { DeleteAccountResponse } from '../models/delete-account.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private baseUrl = environment.apiUrl;
  private userSubject = new BehaviorSubject<UserDto | null>(null);
  user$ = this.userSubject.asObservable();

  constructor(private http: HttpClient, private authService: AuthService) {}

  loadMe(): Observable<UserDto> {
    return this.http.get<UserDto>(`${this.baseUrl}/users/me`).pipe(
      tap(user => this.userSubject.next(user)),
      catchError(err => {
        if (err?.status === 404) {
          this.authService.logout();
          this.userSubject.next(null);
        }
        return throwError(() => err);
      })
    );
  }

  updatePremium(payload: UpdatePremiumDto): Observable<UserDto> {
    return this.http.patch<UserDto>(`${this.baseUrl}/users/me/premium`, payload).pipe(
      tap(user => this.userSubject.next(user))
    );
  }

  setUser(user: UserDto | null): void {
    this.userSubject.next(user);
  }

  get currentUser(): UserDto | null {
    return this.userSubject.value;
  }

  deleteAccount(): Observable<DeleteAccountResponse> {
    return this.http.delete<DeleteAccountResponse>(`${this.baseUrl}/users/me`);
  }
}
